<template>
  <div @click="clickFolderMarker" ref="folderMarker" class="folderMarker alibabaPuHuiTiFontFamily"
       :style="{'width':folderMarkerSize+'px','height':folderMarkerSize+'px','background-image':'url(' + folderMarkerInfo.picture + ')'}">

    <!--hover蒙层-->
    <div class="folderMarkerHoverMantle folderMarkerHoverShow" style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100%;height:100%;background:rgba(0, 0, 0, 0.4);border-radius:10px;"></div>

    <div class="folderMarker-title">
      <p style="width:calc(100% - 30px);margin:0;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;float:left;text-shadow: 0px 0px 4px  rgba(0, 0, 0, 0.75);">{{folderMarkerInfo.labelName}}</p>
    </div>

<!--    <div v-show="hover && folderMarkerInfo.province!==''" style="position:absolute;top:0;bottom:0;left:0;right:0;background:linear-gradient(rgba(204, 204, 204, 0) 0%,rgba(0, 0, 0, 0.32) 45.45%,rgba(0, 0, 0, 0.8) 100%);">-->
<!--      <div style="position:absolute;bottom:5px;left:0;right:0;padding:0 5px;text-align:center;">-->
<!--        <p style="word-break:keep-all;font-size:14px;color:#ffffff;line-height:17px;">{{folderMarkerInfo.province}}</p>-->
<!--      </div>-->
<!--    </div>-->


    <!--hover说明文字-->
    <div class="folderMarkerHoverShow" style="position:absolute;bottom:8px;left:0;right:0;width:100%;height:17px;padding:0 10px;font-size:14px;color:#ffffff;">
      <p style="line-height:17px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;" class="ma-0">{{folderMarkerInfo.remark}}</p>
    </div>

  </div>

</template>

<script>
import mapboxgl from "mapbox-gl";
export default {
  name: "FolderMarker",
  props:["folderMarkerInfo","folderMarkerSize"],
  data() {
    return {
      marker: '',
    }
  },
  methods:{
    clickFolderMarker(){
      this.$emit("clickFolderMarker",this.folderMarkerInfo)
    },
  },
  mounted() {
    this.marker = new mapboxgl.Marker(this.$refs.folderMarker)
        .setLngLat([this.folderMarkerInfo.lon, this.folderMarkerInfo.lat])
        .addTo(this.$parent.$parent.map)
  },
  destroyed() {
    this.marker.remove()
  },
  render() {
    return null;
  },

}
</script>

<style scoped>

.folderMarker{
  position:absolute;
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius:10px;
  background-size:cover;
  background-position: center;
  box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.2);
  cursor:pointer;
}
/*背景图四周做成模糊效果*/
.folderMarker:after {
  position: absolute;
  content: '';
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius:9px;
  box-shadow:0 0 4px 1px rgba(255,255,255,0.8) inset;
}


.folderMarkerHoverShow{
  display:none;
}
.folderMarker:hover .folderMarkerHoverShow{
  display:block;
}

/*hover蒙层出现动画*/
@keyframes folderMarkerHoverMantleShow {
  from {width:0;height:0;}
  to {width:100%;height:100%;}
}
.folderMarkerHoverMantle{
  animation: folderMarkerHoverMantleShow 0.03s linear;
}



.folderMarker-title{
  position:absolute;
  top:8px;
  left:11px;
  width:calc(100% - 14px);
  font-size:16px;
  color:#ffffff;
}


</style>